import logo from './logo.svg';
import './App.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // 
import SignIn from './components/SignIn';  // Import the SignIn component
import OTPPage from './components/OTPPage'; // Import the OTPPage component
import CircleFilter from './components/CircleFilter';
import Registration from './components/Registration';
import SetPassword from './components/SetPassword';  // 
import MapComponent from './components/MapComponent';  // 
import PointComponent from './components/PointComponent';
import ResetPassword from './components/ResetPasswordPage';
import ForgotPasswordRequest from './components/ForgotPasswordPage';


import Profile from './components/Profile';
import ProfilePage from './components/Manage';
import Feedback from './components/Feedback';
import AddToHomeScreen from './components/AddToHomeScreen'; // 
import ChangePassword from './components/ChangePassword1';
import PointScreen from './components/PointScreen';
import StripeIntegrationPage from './components/StripeIntegrationPage';
import PaymentSuccessPage from './components/PaymentSuccessPage';
// import PaymentFailurePage from './components/PaymentFailurePage';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentFailure from './components/PaymentFailure';
import PaymentForm from './components/PaymentForm';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Header from './components/Header';
import ParcelScreen from "./components/ParcelScreen";
import FemaComponent from './components/FemaComponent';
import CountyComponent from './components/CountyComponent';
import CountygeojsonComponent from './components/CountygeojsonComponent';
import NCComponent from './components/NCComponent';
import CarolinaComponent from './components/CarolinaComponent';
// import ParcelScreen from "./components/Parcels/ParcelScreen";
// import ParcelScreen from "./components/Parcel/ParcelScreen";
// import ParcelScreen from "./components/Parcels1/ParcelScreen";
// import PremiumCheckoutPage from './components/PremiumCheckOut';

// Initialize Stripe
// const stripePromise = loadStripe('pk_test_51Rq76fC5GKbLs6Mr7iQHl54rJYZp3Vz23CnFaBH1EodYvSb10oFyaPnWz3pz9xy60wfiSu0s4S5iEqWxn3s3SF8q00YXARdHV9');
const stripePromise = loadStripe('pk_test_51PWb51CNmy7Ziw7S30NOpJQSmy1y4hfb8ROv7aO99QgglVeTPLbdIrLx2RPWgdu52WKyOgMfcxgEEZ6ZpNbOnpim00hn8gRSwX');
function App() {

  // Define the custom vector tile URL here
  const vectorTilesPolyUrl = 'https://demo.flowlogic.com/tile/data/output';
  const vectorTilesUrl = 'https://demo.flowlogic.com/tile/data/point';
  // const vectorTilesUrl2 = 'https://demo.flowlogic.com/tile/data/points';
  const vectorTilesUrl2 = 'https://demo.flowlogic.com/tile/data/points';
  return (

    // <CircleFilterHexagon/>
    //<CircleFilter/>
    <Router>

      {/* Include the "Add to Home Screen" notification */}
      <AddToHomeScreen />
      <Routes> {/* Replace Switch with Routes */}
        {/* <Route path="/" element={<LandingPage />} />  */}

        <Route path="/" element={<SignIn />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/otp" element={<OTPPage />} />
        {/* <Route path="/dashboard" element={<CircleFilter />} /> */}
        <Route path="/circle" element={<CircleFilter />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/forgot-passord-request" element={<ForgotPasswordRequest />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/manage" element={<ProfilePage />} />
        <Route path="/change-password" element={<ChangePassword />} />


        {/* <Route path="/tile" element={<MapComponent />} /> */}
        <Route path="/tile" element={<MapComponent vectorTilesUrl={vectorTilesPolyUrl} />} />
        <Route path="/point" element={<PointComponent vectorTilesUrl={vectorTilesUrl} />} />
        {/* <Route path="/points" element={<PointScreen vectorTilesUrl={vectorTilesUrl2} />} /> */}
        <Route path="/dashboard" element={<PointScreen vectorTilesUrl={vectorTilesUrl2} />} />
        {/* <Route path="/premium" element={<PremiumCheckoutPage />} /> */}
        <Route path="/parcels" element={<ParcelScreen />} />

        <Route path="/floodrisk" element={<FemaComponent />} />
        <Route path="/county" element={<CountyComponent />} />
        <Route path="/countygeojson" element={<CountygeojsonComponent />} />
        <Route path="/NC" element={<NCComponent />} />
        <Route path="/carolina" element={<CarolinaComponent />} />
        {/* <Route path="/stripe-integration" element={<StripeIntegrationPage />} /> */}

        {/* <Route path="/pricing" element={
          <Elements stripe={stripePromise}>
            <StripeIntegrationPage />
          </Elements>
        } /> */}

        <Route
          path="/pricing"
          element={
            <>
              <Header />
              <main>
                <Elements stripe={stripePromise}>
                  <StripeIntegrationPage />
                </Elements>
              </main>
            </>
          }
        />
        <Route path="/payment" element={
          <Elements stripe={stripePromise}>
            <PaymentForm />
          </Elements>
        } />


        <Route path="/payment-success1" element={<PaymentSuccessPage />} />
        {/* <Route path="/payment-failure" element={<PaymentFailurePage />} /> */}

        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failure" element={<PaymentFailure />} />

        <Route path="/stripe" element={
          <>
            {/* <header className="App-header">
                <h1>React Stripe Payment Generator</h1>
                <p>Secure payment processing with Stripe</p>
              </header> */}
            <Header />

            {/* <main className="App-main"> */}
            <Elements stripe={stripePromise}>
              <PaymentForm />
            </Elements>
            {/* </main> */}

            {/* <footer className="App-footer">
                <p>Powered by React & Stripe</p>
              </footer> */}
          </>
        } />



      </Routes>
    </Router>
  );
}

export default App;




